import { useTranslation } from "react-i18next";
import { TableContainer, TableHead, TableCell, TableRow, Table, TableBody } from "@deere/fuel-react";

const OSReviewContactTables = ({ osContacts }) => {
  const { t } = useTranslation();
  const affiliatedContacts = osContacts.filter((ct) => ct.isGovtAffiliated);
  const nonAffiliatedContacts = osContacts.filter((ct) => !ct.isGovtAffiliated);
  return (
    <div style={{ padding: 16, background: "white", borderRadius: 8, margin: 16 }}>
      <p style={{ fontWeight: 600 }}>{t("os_gov_affiliated_table_header")}</p>
      <TableContainer sx={{ marginBottom: "20px" }} variant="outlined">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ bgcolor: "lightgrey!important", width: "16%!important" }}>{t("os_review_table_column_name")}</TableCell>
              <TableCell sx={{ bgcolor: "lightgrey!important", width: "16%!important" }}>{t("os_review_table_column_ospercent")}</TableCell>
              <TableCell sx={{ bgcolor: "lightgrey!important", width: "17%!important" }}>{t("os_review_table_column_country")}</TableCell>
              <TableCell sx={{ bgcolor: "lightgrey!important", width: "17%!important" }}>{t("os_review_table_column_jobtitle")}</TableCell>
              <TableCell sx={{ bgcolor: "lightgrey!important", width: "17%!important" }}>{t("os_review_table_column_govposition")}</TableCell>
              <TableCell sx={{ bgcolor: "lightgrey!important", width: "17%!important" }}>{t("os_review_table_column_orgname")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {affiliatedContacts.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  {t("os_no_record")}
                </TableCell>
              </TableRow>
            )}
            {affiliatedContacts.map((row) => (
              <TableRow hover key={row.id}>
                <TableCell>
                  {row.lastName}, {row.firstName}
                </TableCell>
                <TableCell>{row.ownershipPercentage}%</TableCell>
                <TableCell>{row.countryOfCitizenship}</TableCell>
                <TableCell>{row.jobTitle}</TableCell>
                <TableCell>{row.positionWithGovtAgency}</TableCell>
                <TableCell>{row.nameOfGovtAgency}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <p style={{ fontWeight: 600 }}>{t("os_nongov_affiliated_table_header")}</p>
      <TableContainer sx={{ marginBottom: "20px" }} variant="outlined">
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ bgcolor: "lightgrey!important" }}>{t("os_review_table_column_lastname")}</TableCell>
              <TableCell sx={{ bgcolor: "lightgrey!important" }}>{t("os_review_table_column_firstname")}</TableCell>
              <TableCell sx={{ bgcolor: "lightgrey!important" }}>{t("os_review_table_column_ospercent")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {nonAffiliatedContacts.length === 0 && (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  {t("os_no_record")}
                </TableCell>
              </TableRow>
            )}
            {nonAffiliatedContacts.map((row) => (
              <TableRow hover key={row.id}>
                <TableCell>{row.lastName}</TableCell>
                <TableCell>{row.firstName}</TableCell>
                <TableCell>{row.ownershipPercentage}%</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default OSReviewContactTables;
